import { ProductsState } from '../types/ProductsState'
import { GetterTree } from 'vuex'

export const getters: GetterTree<ProductsState, any> = {
  getProduct: state => ({ sku }) => state.products.find(product => product.sku === sku),
  getProducts: state => state.products
}
